import { render, staticRenderFns } from "./BrokerageNote.vue?vue&type=template&id=fee6c4f0&scoped=true&"
import script from "./BrokerageNote.vue?vue&type=script&lang=js&"
export * from "./BrokerageNote.vue?vue&type=script&lang=js&"
import style0 from "./BrokerageNote.vue?vue&type=style&index=0&id=fee6c4f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee6c4f0",
  null
  
)

export default component.exports